module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_37.25faa048.mp3";